import type { PsfSharePageState } from './types';

export const mutations = {
	toggleShared: (state: PsfSharePageState, shared: boolean): PsfSharePageState => ({
		...state,
		shared,
	}),
};
